import { InjectionToken } from '@angular/core';
import { SchedulerViewMode } from './scheduler.component';

export interface SchedulerConfig {
  // default minutes per slot
  slotMinutes?: number;
  // default view mode
  viewMode?: SchedulerViewMode;
  // whether to show the live now-line
  showNowLine?: boolean;
  // enable/disable drag & drop globally (default: true)
  dragDrop?: boolean;
  // enable/disable resize globally (default: true)
  resize?: boolean;
  // Optional style tuning via CSS variables. If provided, component will set these CSS variables on host.
  cssVars?: Partial<{
    resourceMinWidth: string; // maps to --resource-min-width
    slotHeight: string;       // maps to --slot-height
    rowHeight: string;        // maps to --row-height
    slotWidth: string;        // maps to --slot-width
    eventGutter: string;      // maps to --event-gutter
  }>;
}

export const SCHEDULER_CONFIG = new InjectionToken<SchedulerConfig>('SCHEDULER_CONFIG', {
  factory: (): SchedulerConfig => ({
    slotMinutes: 30,
    viewMode: 'horizontal',
    showNowLine: true,
    dragDrop: false,
    resize: false
  })
});
